import { useTranslation } from 'react-i18next'

import Spacer from 'components/Spacer'
import Row from 'components/Row'
import { maskValue } from 'utils/helpers'

export default function HourSection({ info }) {
  const { t } = useTranslation()

  return (
    <div>
      <p className="hour_purchase_info">
        {t('home.hourly.modal.purchase_info', { hours: info.hours })}
      </p>
      <Spacer height={15} />
      <Row justify="center">
        <div>
          <p className="price">
            {t('summary.hours_price', { price: maskValue(info.hoursValue) })}
          </p>
          {info.saving && (
            <p className="saving">{t('home.hourly.modal.saving')}</p>
          )}
        </div>
      </Row>
    </div>
  )
}
